import { RxStompConfig } from '@stomp/rx-stomp';
import { StompHeaders } from '@stomp/stompjs';
import { environment } from '../../../../environments/environment';

export const webSocketHeaders = (): StompHeaders => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `bearer ${token}` } : {};
};

export const rxStompConfig = (): RxStompConfig => ({
  webSocketFactory: () => new WebSocket(environment.wsUrl.replace(/^http/, 'ws')),
  connectHeaders: webSocketHeaders(),
  heartbeatIncoming: 0, // Typical value 0 - disabled
  heartbeatOutgoing: 20000, // Typical value 20000 - every 20 seconds
  reconnectDelay: 5000,
  debug: environment.production ? undefined : (m: string) => console.debug(m)
  // logRawCommunication: !environment.production,
  // debug: environment.production
  //   ? undefined
  //   : (msg: string): void => {
  //       console.log(new Date(), msg);
  //     }
});
